// banner 视频链接
export const youtubeMap: Record<string, string> = {
    us: 'https://www.youtube.com/embed/LaxudAGU9BM',
    jp: 'https://www.youtube.com/embed/3qHyojQYVYw',
    kr: 'https://www.youtube.com/embed/rF2CEo9Wz4s',
    it: 'https://www.youtube.com/embed/3iUw9QuMKyE',
    de: 'https://www.youtube.com/embed/hTyH-iYCQMw',
    fr: 'https://www.youtube.com/embed/ub8svvZppdo',
    es: 'https://www.youtube.com/embed/riu5xiyiPbc',
};

// 时间线&任务shopify跳转链接
export const shopnowMay: Record<string, string> = {
    za: 'https://za.ecoflow.com/pages/easter-members-festival',
};

// seller任务shopify跳转链接
export const shopSeller: Record<string, string> = {
    us: 'https://us.ecoflow.com',
    ca: 'https://ca.ecoflow.com',
    za: 'https://za.ecoflow.com',
    au: 'https://au.ecoflow.com',
    eu: 'https://eu.ecoflow.com',
    uk: 'https://uk.ecoflow.com',
    de: 'https://de.ecoflow.com',
    fr: 'https://fr.ecoflow.com',
    es: 'https://es.ecoflow.com',
    it: 'https://it.ecoflow.com',
    jp: 'https://jp.ecoflow.com',
    kr: 'https://kr.ecoflow.com',
};

// app任务跳转链接
export const appUrl: Record<string, string> = {
    us: 'https://www.ecoflow.com/us/oasis-home-energy-management-system',
    ca: 'https://www.ecoflow.com/ca/oasis-home-energy-management-system',
    za: 'https://www.ecoflow.com/za/app',
    au: 'https://www.ecoflow.com/au/app',
    eu: 'https://www.ecoflow.com/eu/oasis-home-energy-management-system',
    uk: 'https://www.ecoflow.com/uk/oasis-home-energy-management-system',
    de: 'https://www.ecoflow.com/de/oasis-home-energy-management-system',
    fr: 'https://www.ecoflow.com/fr/oasis-home-energy-management-system',
    es: 'https://www.ecoflow.com/es/oasis-home-energy-management-system',
    it: 'https://www.ecoflow.com/it/oasis-home-energy-management-system',
    jp: 'https://www.ecoflow.com/jp/app',
    kr: 'https://www.ecoflow.com/kr/support/warranty',
};
